import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks.ts';
import useWidgetStream from 'widgets/streaming/useWidgetStream.ts';
import React, { useState } from 'react';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { useVolumeCurveDimensions } from 'widgets/volumeCurve/components/dimensions.ts';
import {
    OrderVolumeProfileData,
    useOrderVolumeProfileData,
} from 'widgets/orderVolumeProfile/data/orderVolumeProfileData';
import OrderVolumeProfileHeader from './header/OrderVolumeProfileHeader';
import './OrderVolumeProfile.scss';
import OrderVolumeProfileGrid from './grid/OrderVolumeProfileGrid.tsx';

export default function OrderVolumeProfile() {
    const { widgetKey } = useWidgetContext();
    const data = useOrderVolumeProfileData();

    const [gridApi, setGridApi] = useState<GridApi | undefined>();

    useWidgetStream();

    const { bodyHeight } = useVolumeCurveDimensions();

    const onGridApiSet = (api: GridApi) => {
        setGridApi(api);
    };

    return (
        <div className="OrderVolumeProfile" data-widget-id={widgetKey}>
            <OrderVolumeProfileHeader
                data={data}
                messages={[]}
                gridApi={gridApi}
            />
            <div className="widget-body" style={{ height: bodyHeight }}>
                <WidgetBody data={data} onGridApiSet={onGridApiSet} />
            </div>
        </div>
    );
}

export function WidgetBody({
    data,
    onGridApiSet,
}: {
    data: OrderVolumeProfileData;
    onGridApiSet: (gridApi: GridApi) => void;
}) {
    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();
    if (!hasValidSelection) {
        return <></>;
    }

    return (
        <OrderVolumeProfileGrid
            data={data.bucketedData}
            onGridApiSet={onGridApiSet}
        />
    );
}
